import React from 'react';
import { Navigate } from 'react-router-dom';

const Register: React.FC = () => {
  return <Navigate to="/login?mode=register" replace />;
};

export default Register;